import type { FC } from 'react';
import Link from 'next/link';
import { IconsNames } from '@eqi-investimentos/icons/web';
import { Flex } from '@eqi-investimentos/react';
import { Text } from '@chakra-ui/react';
import { Icon } from '@/components/atoms/Icon';
export const ServiceCard: FC<CrossSellWidgetCardProps> = ({
  path,
  icon,
  title
}) => {
  return <Flex as={Link} href={path} direction="column" w="14.75rem" p="m" gap="xl" bg="background.brandLight" borderRadius="0.625rem" data-sentry-element="Flex" data-sentry-component="ServiceCard" data-sentry-source-file="Card.tsx">
      <Icon iconName={icon as IconsNames} w="1.5rem" h="1.5rem" color="content.brand" data-sentry-element="Icon" data-sentry-source-file="Card.tsx" />
      <Text size="xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="Card.tsx">
        {title}
      </Text>
    </Flex>;
};
type CrossSellWidgetCardProps = {
  path: string;
  icon: string;
  thumb?: string;
  title: string;
};